import { Skeleton } from './Skeleton';

interface SkeletonCardProps {
  /** Matches primary (large) or default FeatureCard sizing */
  primary?: boolean;
}

/**
 * SkeletonCard - Placeholder that mirrors the FeatureCard layout.
 *
 * Keeps the same icon + text + chevron structure so the page
 * doesn't shift when real content loads.
 */
export function SkeletonCard({ primary = false }: SkeletonCardProps) {
  const iconSize = primary ? 'w-14 h-14' : 'w-10 h-10';
  const titleWidth = primary ? 'w-2/3' : 'w-1/2';
  const titleHeight = primary ? 'h-5' : 'h-4';
  const descHeight = primary ? 'h-3.5' : 'h-3';
  const padding = primary ? 'p-6' : 'p-4';

  return (
    <div
      className={`rounded-xl border border-[var(--color-border)] ${padding} animate-pulse`}
      aria-hidden="true"
    >
      <div className="flex items-center gap-4">
        {/* Icon circle */}
        <Skeleton variant="circle" width={iconSize.split(' ')[0]} height={iconSize.split(' ')[1]} />

        {/* Text lines */}
        <div className="flex-1 space-y-2">
          <Skeleton width={titleWidth} height={titleHeight} />
          <Skeleton width="w-1/3" height={descHeight} />
        </div>

        {/* Chevron placeholder */}
        <Skeleton variant="rect" width="w-4" height="h-4" className="shrink-0" />
      </div>
    </div>
  );
}

export default SkeletonCard;
